/**
 * reCAPTCHA helper.
 * In production, calls Google's executeRecaptcha.
 * For automated E2E tests, if `localStorage.setItem('e2e_recaptcha_token', '<SERVER_BYPASS_TOKEN>')`
 * is set before submitting the login form, that exact token is returned and
 * the server will accept it (matches RECAPTCHA_TEST_BYPASS_TOKEN on backend).
 */
export const getRecaptchaToken = async (executeRecaptcha, action) => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      const bypass = window.localStorage.getItem('e2e_recaptcha_token');
      if (bypass) return bypass;
    }
  } catch (_) {
    /* localStorage may be unavailable in some contexts — ignore */
  }
  if (executeRecaptcha) {
    try {
      return await executeRecaptcha(action);
    } catch (_) {
      // e.g. "Invalid domain for site key" — fail open; server treats a
      // missing token as unverified rather than blocking the request.
      return '';
    }
  }
  return '';
};
